import axios from 'axios';
import { toast } from 'react-toastify';
import { filterDemoProductsForList } from '../utils/demoProductLabels.js';

// CRA bakes REACT_APP_* in at compile time; restart dev server after changing .env.
const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api/v1'
).replace(/\/$/, '');

export async function getDailyForecastAll(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/daily/all${query}`);
  if (!resp.ok) {
    throw new Error(`Failed to fetch daily forecast: HTTP ${resp.status}`);
  }
  return resp.json();
}

// 2) New “all‐weekly” fetcher
export async function getWeeklyForecastAll(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/weekly/all${query}`);
  if (!resp.ok) {
    throw new Error(`Failed to fetch weekly forecast: HTTP ${resp.status}`);
  }
  return resp.json();
}

export async function getDailyPrimary(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/dailyprimary${query}`);
  if (!resp.ok) throw new Error("Failed to fetch primary");
  return resp.json();
}

export async function getDailySecondary(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/dailysecondary${query}`);
  if (!resp.ok) throw new Error("Failed to fetch secondary");
  return resp.json();
}

export async function getDailyTertiary(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/dailytertiary${query}`);
  if (!resp.ok) throw new Error("Failed to fetch tertiary");
  return resp.json();
}

export async function getWeeklyPrimary(modelCode) {
  // Build ?model_code=… query param if modelCode is provided
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(
    `${API_BASE_URL}/forecast/weeklyprimary${query}`
  );
  if (!resp.ok) {
    throw new Error(`Failed to fetch weekly primary: HTTP ${resp.status}`);
  }
  return resp.json(); // { weekly: [ …53 ints… ] }
}

export async function getWeeklyTertiary(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(
    `${API_BASE_URL}/forecast/weeklytertiary${query}`
  );
  if (!resp.ok) {
    throw new Error(`Failed to fetch weekly tertiary: HTTP ${resp.status}`);
  }
  return resp.json();
}

export async function getWeeklySecondary(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(
    `${API_BASE_URL}/forecast/weeklysecondary${query}`
  );
  if (!resp.ok) {
    throw new Error(`Failed to fetch weekly secondary: HTTP ${resp.status}`);
  }
  return resp.json();
}

export async function getWeeklyMaster() {
  const resp = await fetch(`${API_BASE_URL}/forecast/weekmasterdata`);
  if (!resp.ok) throw new Error("Failed to fetch weekly master");
  return resp.json();
}

export async function getCurrentWeek() {
  const resp = await fetch(`${API_BASE_URL}/forecast/currentweek`);
  if (!resp.ok) throw new Error("Failed to fetch current week");
  return resp.json();
}

export const getAllProducts = () => {
  return axios.get(`${API_BASE_URL}/forecast/products`).then((res) => ({
    ...res,
    data: filterDemoProductsForList(res.data),
  }));
};

export async function getMonthlyStocksData(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/stocks/stock/monthly${query}`);
  if (!resp.ok) {
    throw new Error(`Failed to fetch monthly stocks data: HTTP ${resp.status}`)
  }
  return resp.json();
}
export async function getWeeklyStocksData(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/stocks/stock/weekly${query}`);
  if (!resp.ok) {
    throw new Error(`Failed to fetch weekly stocks data: HTTP ${resp.status}`)
  }
  return resp.json();
}

export async function getMonthlyDriversData(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/drivers/monthly${query}`);
  if (!resp.ok) {
    throw new Error(`Failed to fetch weekly stocks data: HTTP ${resp.status}`)
  }

  return resp.json()
}
export async function getWeeklyDriversData(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/drivers/weekly${query}`);
  if (!resp.ok) {
    throw new Error(`Failed to fetch weekly stocks data: HTTP ${resp.status}`)
  }

  return resp.json()
}

export async function getMonthlyInputsData(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/inputs/monthly${query}`);
  if (!resp.ok) {
    throw new Error(`Failed to fetch weekly input data: HTTP ${resp.status}`)
  }

  return resp.json()
}

export async function getWeeklyInputData(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/inputs/weekly${query}`);
  if (!resp.ok) {
    throw new Error(`Failed to fetch all default input data: HTTP ${resp.status}`)
  }

  return resp.json()
}

export async function getAllDefaultInputData(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/inputs/all_defaults${query}`);
  if (!resp.ok) {
    throw new Error()
  }
  return resp.json()
}

export async function getMonthlyForecastTertiary(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/tertiary/monthly${query}`);
  if (!resp.ok) {
    throw new Error(`Failed to fetch weekly stocks data: HTTP ${resp.status}`)
  }

  return resp.json()
}
export async function getWeeklyForecastTertiary(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/tertiary/weekly${query}`);
  if (!resp.ok) {
    throw new Error(`Failed to fetch weekly stocks data: HTTP ${resp.status}`)
  }

  return resp.json()
}

export async function updateProjectionValues(modelCode, current_week_no, input_values) {
  // console.log("input_values", modelCode, typeof modelCode, typeof week_no, current_week_no, typeof current_week_no, input_values, typeof input_values)
  const query = (modelCode && current_week_no && input_values) ? `?model_code=${encodeURIComponent(modelCode)}&current_week_no=${encodeURIComponent(current_week_no)}` : "";
  console.log("created API", `${API_BASE_URL}/forecast/update_week${query}`)
  try {

    const resp = await fetch(`${API_BASE_URL}/forecast/update_week${query}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(input_values)
    });
    if (resp.ok) {
      toast.success("Data has been updated!")
    }
    const updatedValues = await resp.json();
    console.log("updatedValues", updatedValues)
    return updatedValues;
  } catch (err) {
    toast.error("An error occurred while updating the data.");
  }
}


export async function fetchWeeklyReport(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/weekly_reports${query}`)
  const data = await resp.json();
  return data;
}

export async function fetchSopReport(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/sopreports${query}`)
  const data = await resp.json();
  return data;
}

export async function fetchFcReport(modelCode) {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const resp = await fetch(`${API_BASE_URL}/forecast/fcreports${query}`)
  const data = await resp.json();
  return data;
}

export async function fetchAllReport() {
  const resp = await fetch(`${API_BASE_URL}/forecast/allreports`)
  const data = await resp.json();
  return data;
}

export async function fetchAccuracyReport() {
  const resp = await fetch(`${API_BASE_URL}/forecast/accuracy_reports`);
  if (!resp.ok) throw new Error(`Failed to fetch accuracy report: HTTP ${resp.status}`);
  return resp.json();
}

export const saveSopEditedProjectionToBackendasync = async (modelCode, projected) => {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const res = await fetch(`${API_BASE_URL}/forecast/save_sop_changes${query}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    },
    body: JSON.stringify(projected)
  });
  if (res.ok) {
    toast.success("Data has been saved!")
  }
  return res.data;
};

export const saveEditedProjectionToBackendasync = async (modelCode, projected) => {
  const query = modelCode ? `?model_code=${encodeURIComponent(modelCode)}` : "";
  const res = await fetch(`${API_BASE_URL}/forecast/save_changes${query}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    },
    body: JSON.stringify(projected)
  });
  if (res.ok) {
    toast.success("Data has been saved!")
  }
  return res.data;
};

// Version schema APIS
export const getWeeks_versionsForMonth = async (modelCode, month_key) => {
  const query = `?model_code=${encodeURIComponent(modelCode)}&month_key=${encodeURIComponent(month_key)}`;
  const res = await fetch(`${API_BASE_URL}/versions/get-weeks-versions${query}`, { method: "GET" });
  return res.json();
}

export const getVersionsData = async (modelCode, week_no, version) => {
  const query = `?model_code=${encodeURIComponent(modelCode)}&week_no=${week_no}&version=${version}`;
  const res = await fetch(`${API_BASE_URL}/versions/get-projection-version-data${query}`, { method: "GET" });
  return res.json();
}

export const updateLatestVersion = async (modelCode, week_no, version) => {
  const query = `?model_code=${encodeURIComponent(modelCode)}&week_no=${week_no}&version=${version}`;
  const res = await fetch(`${API_BASE_URL}/versions/update-latest-version${query}`, { method: "PATCH" });
  if (res.ok) {
    toast.success("Version has been updated as latest!")
  }
  return res.json();
}